import { Icon } from '@rocketmakers/armstrong';
import * as React from 'react';
import { SeroProps } from '../../props/SeroProps';
import './device-summary.scss';

type Field = {
  name: string;
  value: string | number;
};

type DeviceSummaryProps = {
  name?: string;
  onSelect?: () => void;
  fields: Field[];
} & SeroProps;

export const DeviceSummary: React.FunctionComponent<DeviceSummaryProps> = ({
  fields,
  name,
  onSelect,
  'data-qa': dataQa = 'device-summary',
}) => {
  return (
    <div className="device-summary" data-qa={dataQa}>
      {name && (
        <>
          {/* rome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
          <div
            className={`row device-summary__title ${onSelect ? 'device-summary__title-selectable' : ''}`}
            onClick={onSelect}
            data-qa={`${dataQa}-title`}
          >
            <h3>{name}</h3>
            {onSelect && <Icon icon={Icon.Icomoon.pencil} />}
          </div>
          <div className="device-summary__divider" />
        </>
      )}
      {fields.map(field => (
        <div className="row device-summary__row" key={field.name} data-qa={`${dataQa}-row`}>
          <div>
            <p className="device-summary__row-key" data-qa={`${dataQa}-row-key`}>
              {field.name}
            </p>
          </div>
          <div>
            <p className="device-summary__row-value" data-qa={`${dataQa}-row-value`}>
              {field.value}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};
